export const reduxStateMiddleware = () => next => action => {
    let result = next(action);
    return result;
};
